<template>
  <abk-company-list companiesType="rejected"/>
</template>

<script>
import AbkCompanyList from '../../../components/companies/AbkCompanyList'

export default {
  name: 'RejectedCompaniesTab',
  components: { AbkCompanyList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.companies.companies_index.title'),
        subtitle: this.$t('views.companies.companies_index.rejected')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
</style>
